import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------ English ------------------------------ */
i18next.addResources(locales.EN, 'MARRIAGES_FORM', {
  TITLE: 'Marriage Procedure Form',
  GROOM: 'Groom',
  BRIDE: 'Bride',
  PARENTS: 'Parents',
  GRANDPARENTS: 'Grandparents',
  WITNESSES: 'Witnesses',
  CEREMONY: 'Ceremony',
  DOCUMENTS: 'Documents',
  COMMENTS: 'Comments',
  GROOM_INFORMATION: 'Groom information',
  BRIDE_INFORMATION: 'Bride information',
  GROOM_PARENTS_INFORMATION: 'Groom parents information',
  BRIDE_PARENTS_INFORMATION: 'Bride parents information',
  GROOM_GRANDPARENTS_INFORMATION: 'Groom grandparents information',
  BRIDE_GRANDPARENTS_INFORMATION: 'Bride grandparents information',
  GROOM_WITNESSES_INFORMATION: 'Groom witnesses information',
  BRIDE_WITNESSES_INFORMATION: 'Bride witnesses information',
  CEREMONY_INFORMATION: 'Ceremony information',
  DOCUMENTS_INFORMATION: 'Documents information',
  FIRST_NAME: 'First names',
  LAST_NAME: 'Last names',
  ID_CARD_TYPE: 'ID card type',
  ID_CARD: 'ID card',
  ID_CARD_FILE: 'ID card file',
  ID_CARD_BACK_FILE: 'ID card back file',
  EMAIL: 'Email',
  AREA_CODE: 'Area code',
  PHONE: 'Phone',
  COMMUNITY: 'Community',
  CIVIL_STATE: 'Civil state',
  TRIBE: 'Cohen, Levi or Israel',
  ADDRESS: 'Address',
  APARTMENT: 'Floor/Apartment',
  LOCALITY: 'locality',
  COUNTRY: 'Country',
  BIRTHDATE: 'Birthdate',
  BIRTHPLACE: 'Birthplace',
  JOB: 'Job',
  GET_FILE: 'Get',
  FATHER_LAST_NAME: 'Father last name',
  MOTHER_LAST_NAME: 'Mother last name',
  FATHER_NAME: 'Father first name',
  MOTHER_NAME: 'Mother first name',
  WEDDING_TEMPLE: 'Temple where the parents were married',
  WEDDING_DATE: 'Jupa wedding date',
  ALIVE: 'Is alive?',
  CEMENTERY: 'Cementery',
  PATERNAL_FATHER_NAME: 'Paternal father name',
  PATERNAL_FATHER_LAST_NAME: 'Paternal father last name',
  PATERNAL_MOTHER_NAME: 'Paternal mother name',
  PATERNAL_MOTHER_LAST_NAME: 'Paternal mother last name',
  MATERNAL_FATHER_NAME: 'Maternal father name',
  MATERNAL_FATHER_LAST_NAME: 'Maternal father last name',
  MATERNAL_MOTHER_NAME: 'Maternal mother name',
  MATERNAL_MOTHER_LAST_NAME: 'Maternal mother last name',
  WITNESS_NAME: 'Full name of the witness',
  KETUBA_FILE: 'Ketubá',
  MARRIAGE_CERTIFICATE_FILE: 'Marriage certificate',
  CEREMONY_RELIGIOUS_DATE: 'Religious date',
  CEREMONY_CIVIL_DATE: 'Civil date',
  CEREMONY_OFFICIANT: 'Officiant',
  CEREMONY_CIVIL_LOCALITY: 'Civil locality',
  FILES: 'Files',
  DELETE_DIALOG_TITLE: 'Delete marriage file',
  DELETE_DIALOG_MESSAGE: 'Are you sure you want to delete the file <strong>{{ name }}</strong>?',
  SUBMIT_BUTTON: 'Submit',
  LOADING: 'Loading...',
});

/* ------------------------------ Spanish ------------------------------ */
i18next.addResources(locales.ES, 'MARRIAGES_FORM', {
  TITLE: 'Formulario de Casamiento',
  GROOM: 'Novio',
  BRIDE: 'Novia',
  PARENTS: 'Padres',
  GRANDPARENTS: 'Abuelos',
  WITNESSES: 'Testigos',
  CEREMONY: 'Ceremonia',
  DOCUMENTS: 'Documentos',
  COMMENTS: 'Observaciones',
  GROOM_INFORMATION: 'Información del novio',
  BRIDE_INFORMATION: 'Información de la novia',
  GROOM_PARENTS_INFORMATION: 'Información de los padres del novio',
  BRIDE_PARENTS_INFORMATION: 'Información de los padres de la novia',
  GROOM_GRANDPARENTS_INFORMATION: 'Información de los abuelos del novio',
  BRIDE_GRANDPARENTS_INFORMATION: 'Información de los abuelos de la novia',
  GROOM_WITNESSES_INFORMATION: 'Información de los testigos del novio',
  BRIDE_WITNESSES_INFORMATION: 'Información de los testigos de la novia',
  CEREMONY_INFORMATION: 'Información de la ceremonia',
  DOCUMENTS_INFORMATION: 'Información de los documents',
  FIRST_NAME: 'Nombres',
  LAST_NAME: 'Apellidos',
  ID_CARD_TYPE: 'Tipo de documento',
  ID_CARD: 'Documento',
  ID_CARD_FILE: 'Documento frente (escaneado)',
  ID_CARD_BACK_FILE: 'Documento dorso (escaneado)',
  EMAIL: 'Email',
  AREA_CODE: 'Código de área',
  PHONE: 'Celular',
  COMMUNITY: 'Comunidad',
  CIVIL_STATE: 'Estado civil',
  TRIBE: 'Cohen, Levi o Israel (Si dudas, elegí Israel)',
  ADDRESS: 'Domicilio',
  APARTMENT: 'Piso/Departamento',
  LOCALITY: 'Localidad',
  COUNTRY: 'País',
  BIRTHDATE: 'Fecha de nacimiento',
  BIRTHPLACE: 'Lugar de nacimiento',
  JOB: 'Ocupación',
  GET_FILE: 'Get',
  FATHER_LAST_NAME: 'Apellido del padre',
  MOTHER_LAST_NAME: 'Apellido de la madre',
  FATHER_NAME: 'Nombre del padre',
  MOTHER_NAME: 'Nombre de la madre',
  WEDDING_TEMPLE: 'Templo donde se casaron los padres',
  WEDDING_DATE: 'Fecha de casamiento de jupá',
  ALIVE: 'Está con vida?',
  CEMENTERY: 'Cementerio',
  PATERNAL_FATHER_NAME: 'Nombre del abuelo paterno',
  PATERNAL_FATHER_LAST_NAME: 'Apellido del abuelo paterno',
  PATERNAL_MOTHER_NAME: 'Nombre de la abuela paterna',
  PATERNAL_MOTHER_LAST_NAME: 'Apellido de la abuela paterna',
  MATERNAL_FATHER_NAME: 'Nombre del abuelo materno',
  MATERNAL_FATHER_LAST_NAME: 'Apellido del abuelo materno',
  MATERNAL_MOTHER_NAME: 'Nombre de la abuela materna',
  MATERNAL_MOTHER_LAST_NAME: 'Apellido de la abuela materna',
  WITNESS_NAME: 'Nombre completo del testigo',
  KETUBA_FILE: 'Ketubá',
  MARRIAGE_CERTIFICATE_FILE: 'Libreta de casamiento',
  CEREMONY_RELIGIOUS_DATE: 'Fecha y hora de la ceremonia religiosa',
  CEREMONY_CIVIL_DATE: 'Fecha y hora del casamiento civil',
  CEREMONY_OFFICIANT: 'Nombre del oficiante de la ceremonia',
  CEREMONY_CIVIL_LOCALITY: 'Localidad del casamiento civil',
  FILES: 'Archivos',
  DELETE_DIALOG_TITLE: 'Eliminar archivo del casamiento',
  DELETE_DIALOG_MESSAGE: 'Estás seguro de querer eliminar el archivo <strong>{{ name }}</strong>?',
  SUBMIT_BUTTON: 'Enviar',
  LOADING: 'Cargando...',
});
